export default __webpack_public_path__ + "static/media/GoodMannersWithYourFriends_00.6f9a5c08.png";